<template>
  <div class="col-span-12 lg:col-span-8 xxl:col-span-9">
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">
        Captain Dashboard Alerts & Notices
      </h2>
    </div>
    <div class="mt-5">
      <!-- BEGIN: Captains Alerts Content -->
      <div class="config-content">
        <form class="validate-form" @submit.prevent="saveEventSettings">
          <div class="grid grid-cols-12 gap-6">
            <div class="col-span-12">
              <div class="intro-y box mt-2 p-6">
                <div>
                  <div
                    class="grid grid-cols-12 gap-6 border border-solid border-gray-200 p-6 mb-6"
                  >
                    <div class="col-span-12">
                      <h3 class="text-base font-medium">
                        New Captain Alert
                      </h3>
                      <p class="italic">
                        Create Alerts to go on the Captain Dashboard.
                      </p>
                    </div>
                    <div class="col-span-12">
                      <label
                        for="button_url"
                        class="form-label placeholder-label relative w-full mt-3 text-base"
                      >
                        <input
                          id="button_url"
                          v-model="newCaptainAlert.headline"
                          type="text"
                          class="form-control p-3"
                          placeholder=" "
                        />
                        <span
                          class="p-3 absolute opacity-50 left-0 top-0 transition-all duration-300 ease-in-out text-base"
                          >Headline</span
                        >
                      </label>
                    </div>
                    <div class="col-span-12">
                      <label
                        for="alert_text"
                        class="form-label placeholder-label relative w-full mt-3 text-base"
                      >
                        <textarea
                          id="alert_text"
                          v-model="newCaptainAlert.text"
                          rows="5"
                          name="captainAlertText"
                          class="form-control p-3"
                          placeholder=" "
                        />
                        <span
                          class="p-3 absolute opacity-50 left-0 top-0 transition-all duration-300 ease-in-out text-base"
                          >Alert Message</span
                        >
                      </label>
                    </div>
                    <div class="col-span-12 lg:col-span-4 mt-4">
                      <button
                        class="btn btn-outline-primary"
                        type="button"
                        @click="addCaptainAlert()"
                      >
                        Add Captain Alert
                      </button>
                    </div>
                  </div>
                </div>
                <h2 class="col-span-12 text-base font-medium">
                  Current Captain Alerts
                </h2>
                <ul
                  v-if="eventSettings && eventSettings.captainAlerts"
                  class="mt-2"
                >
                  <li
                    v-for="(alert, index) in eventSettings.captainAlerts"
                    :key="index"
                  >
                    <div
                      class="grid grid-cols-12 gap-6 mb-2 border border-solid border-gray-400 p-3"
                    >
                      <div class="col-span-9">
                        <span class="block font-medium text-base">{{
                          alert.headline
                        }}</span>
                        <span class="block">{{ alert.text }}</span>
                      </div>
                      <div class="col-span-3 text-right">
                        <button
                          class="btn btn-sm btn-red mt-1"
                          type="button"
                          @click="removeCaptainAlert(index)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
                <div v-if="eventSettings && eventSettings.captainAlerts">
                  <h4 v-if="eventSettings.captainTools.length === 0">
                    No captain alerts have been added.
                  </h4>
                </div>
                <div class="flex justify-end mt-8">
                  <button
                    type="submit"
                    class="btn btn-lg btn-primary w-20 mr-auto"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- END: Captains Tools Content -->
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, reactive } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { useStore } from "@/store";
import { updateEventSettings } from "@/api/event-settings";

export default defineComponent({
  setup() {
    const validate = useVuelidate();
    const store = useStore();
    const eventSettings = computed(() => store.getters["main/eventSettings"]);

    const newCaptainAlert = reactive({});

    const addCaptainAlert = () => {
      if (newCaptainAlert.headline && newCaptainAlert.text) {
        saveAlertToStore();
      }
    };

    const removeCaptainAlert = async index => {
      await store.dispatch("main/removeCaptainAlert", index);
    };

    const saveAlertToStore = async () => {
      const captainAlert = {};
      Object.assign(captainAlert, newCaptainAlert);
      await store.dispatch("main/addCaptainAlert", captainAlert);
      newCaptainAlert.headline = "";
      newCaptainAlert.text = "";
    };

    const sendNotification = async response => {
      let note = {
        show: true,
        title: "Success",
        message: "Event settings have been updated."
      };
      if (response.code) {
        note = {
          show: true,
          error: true,
          title: "Error",
          message: "There was a problem updating the event settings."
        };
      }
      await store.dispatch("notifications/displayNotification", note);
    };

    const saveEventSettings = async () => {
      validate.value.$touch();
      if (validate.value.$invalid) {
        let response = {
          code: 400
        };
        await sendNotification(response);
      } else {
        const saveEventSettingsResult = await updateEventSettings(
          eventSettings.value
        );
        await sendNotification(saveEventSettingsResult);
      }
    };

    return {
      eventSettings,
      saveEventSettings,
      newCaptainAlert,
      addCaptainAlert,
      removeCaptainAlert
    };
  }
});
</script>
